import { render } from "./carousel.vue?vue&type=template&id=71468deb&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=71468deb&scoped=true&lang=css"
import "./carousel.vue?vue&type=style&index=1&id=71468deb&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71468deb"]])

export default __exports__